import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'

export default function Datenschutz() {
  const location = useLocation()
  const isDashboard = location.pathname.startsWith('/dashboard')
  return (
    <PageShell>
      <div className="max-w-3xl space-y-6">
        <SectionTitle title="Datenschutzerklärung" />
        <Card className="p-6 space-y-6 text-sm text-white/90">
          <p className="text-white/70">
            Diese Datenschutzerklärung informiert Sie über die Verarbeitung personenbezogener Daten im Rahmen der Anwendung „AI Mastering Studio“ (im Folgenden „Dienst“) und erfüllt die Anforderungen der Datenschutz-Grundverordnung (DSGVO).
          </p>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">1. Verantwortlicher</h2>
            <p>
              Verantwortlich für die Datenverarbeitung ist:<br />
              anwendungen.online / Marc Fischer (DJ Mac).<br />
              Weitere Kontaktdaten: <a href="https://anwendungen.online" target="_blank" rel="noopener noreferrer" className="text-violet-300 hover:underline">anwendungen.online</a>.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">2. Welche Daten werden verarbeitet?</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Kontodaten:</strong> E-Mail-Adresse, Passwort (verschlüsselt gespeichert), Angabe ob Sie Benachrichtigungen wünschen (optional).</li>
              <li><strong>Nutzungsdaten:</strong> Hochgeladene Audiodateien und daraus erzeugte Dateien (Master, Berichte, Cover, Canvas), zugehörige Metadaten (z. B. Titel, Genre), Credits und Transaktionsdaten.</li>
              <li><strong>Technische Daten:</strong> Bei Anmeldung und Nutzung können Protokolldaten (z. B. IP-Adresse, Zeitpunkt) anfallen; diese werden nur im technisch erforderlichen Umfang und unter Beachtung der Speicherfristen verarbeitet.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">3. Zweck und Rechtsgrundlage</h2>
            <p>
              Die Verarbeitung erfolgt zur Bereitstellung des Dienstes (Vertragserfüllung bzw. vorvertragliche Maßnahmen, Art. 6 Abs. 1 lit. b DSGVO), zur Erfüllung rechtlicher Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO) und, soweit Sie eingewilligt haben, z. B. für Benachrichtigungen (Art. 6 Abs. 1 lit. a DSGVO). Die Verarbeitung Ihrer Audiodaten und Metadaten dient ausschließlich der Durchführung des von Ihnen gewählten Masterings und der Bereitstellung der Ergebnisse.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">4. Speicherdauer</h2>
            <p>
              Kontodaten und von Ihnen hochgeladene bzw. erzeugte Inhalte werden gespeichert, solange Ihr Konto besteht. Nach Löschung Ihres Kontos werden personenbezogene Daten und die Ihrem Konto zugeordneten Inhalte gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Protokolldaten werden nur im technisch und rechtlich erforderlichen Umfang und für begrenzte Zeit vorgehalten.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">5. Empfänger und Drittanbieter</h2>
            <p>
              Zur Bereitstellung des Dienstes können Auftragsverarbeiter eingesetzt werden (z. B. Hosting, E-Mail-Versand). Die Verarbeitung für KI-basierte Schritte (z. B. Analyse, Cover-Vorschläge) kann unter Einbindung von Diensten Dritter erfolgen (z. B. OpenAI); dabei werden nur die dafür erforderlichen Daten übermittelt. Bei Zahlungsabwicklung können Zahlungsdienstleister (z. B. Stripe) tätig werden. Mit allen Auftragsverarbeitern bestehen Vereinbarungen im Sinne von Art. 28 DSGVO.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">6. Ihre Rechte (DSGVO)</h2>
            <p>Sie haben unter den gesetzlichen Voraussetzungen:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li><strong>Auskunft</strong> (Art. 15 DSGVO) über Ihre gespeicherten Daten,</li>
              <li><strong>Berichtigung</strong> (Art. 16 DSGVO) unrichtiger Daten,</li>
              <li><strong>Löschung</strong> (Art. 17 DSGVO) bzw. „Recht auf Vergessenwerden“,</li>
              <li><strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO),</li>
              <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO) in einem gängigen Format,</li>
              <li><strong>Widerspruch</strong> (Art. 21 DSGVO) gegen die Verarbeitung, soweit diese auf berechtigten Interessen beruht,</li>
              <li>das Recht, eine <strong>Beschwerde</strong> bei einer Aufsichtsbehörde (Art. 77 DSGVO) einzulegen.</li>
            </ul>
            <p className="mt-3">
              Im Dienst können Sie unter <strong>Einstellungen → Datenschutz & Ihre Rechte</strong> Ihre Daten exportieren und Ihr Konto inklusive zugehöriger Daten löschen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">7. Cookies und technisch notwendige Speicherung</h2>
            <p>
              Es werden nur technisch notwendige Speicherungen genutzt (z. B. Anmeldestatus im lokalen Speicher oder Session-Speicher Ihres Browsers), die für die Nutzung des Dienstes erforderlich sind. Es erfolgt kein Einsatz von Tracking- oder Marketing-Cookies ohne Ihre Einwilligung.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">8. Änderungen</h2>
            <p>
              Diese Datenschutzerklärung kann bei Bedarf angepasst werden. Wesentliche Änderungen werden Sie bei Nutzung des Dienstes oder per E-Mail informieren, soweit wir Ihre Kontaktdaten dafür nutzen dürfen.
            </p>
          </section>

          <p className="text-white/60 pt-4 border-t border-white/10">
            Stand: Februar 2025. Bei Fragen wenden Sie sich an den Verantwortlichen über anwendungen.online.
          </p>
        </Card>
        <p className="text-center">
          <Link to={isDashboard ? '/dashboard' : '/'} className="text-violet-300 hover:underline">
            ← {isDashboard ? 'Zum Dashboard' : 'Zur Startseite'}
          </Link>
        </p>
      </div>
    </PageShell>
  )
}
